import type { FormattedError } from 'src/api/utils/format-error';

import { useNavigate } from 'react-router';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { adminKeys } from 'src/api/admin/query-keys';
import { adminLogout, getAdminInfo } from 'src/api/admin/auth';

export function useAdminAuth() {
  const {
    data: user,
    error,
    isLoading,
  } = useQuery({
    queryKey: adminKeys.adminInfo,
    queryFn: getAdminInfo,
    retry: false,
  });
  const statusCode = (error as FormattedError | null)?.statusCode;

  return { user, isLoading, isAuthenticated: !!user, isForbidden: statusCode === 403 };
}

export function useAdminLogout() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate: logout } = useMutation({
    mutationFn: adminLogout,
    onSettled: () => {
      queryClient.removeQueries({ queryKey: ['admin'] });
      navigate('/admin/login');
    },
  });

  return { logout: () => logout() };
}
